module.exports = __webpack_public_path__ + "static/media/saptak.3c817b2c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContactUs/static/images/brands/saptak.jpg
// module id = 69
// module chunks = 1